import blacklogo from "../blacklogo.svg"
import photo1 from "../images/NFT Pic.png"
import art1 from "../images/art-1.jpeg"
import art2 from "../images/art-2.jpeg"
import art3 from "../images/art-3.jpeg"
import art4 from "../images/art-4.jpeg"
import art5 from "../images/art-5.jpeg"
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Marketplace() {

    return (
        <div className="overflow-hidden bg-blue">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
              <div className="mx-auto max-w-5xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                <div className="w-full max-w-xl lg:shrink-0 xl:max-w-3xl">
                  <h1 className="text-5xl not-italic font-bold font-title text-white">
                    Explore our Secure Ticket Resale Markeplace 
                  </h1>
                  <p className="relative mt-6 text-base not-italic font-normal leading-6 font-text text-white sm:max-w-md lg:max-w-none">
                  One hour prior to the start of each event, the marketplace will be closed for the event in question. This guarantees that all NFTs listed on the platform are either in Phase 1 or Phase 3 eliminating any chance of buying a duplicate ticket on our marketplace.
                  </p>
                  <Link 
                    to="/marketplace"
                    onClick={() => {
                        window.scroll(0, 0);
                    }}
                  >
                  <button className="inline-flex flex-col items-center text-white py-3 px-5 rounded-md mt-5 mx-5 bg-background">
                        View Markeplace
                  </button>
                  </Link>
                </div>
                <div className="mt-14 flex justify-end gap-8 sm:-mt-44 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0">
                  <div className="ml-auto w-44 flex-none space-y-8 pt-32 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
                    <div className="relative">
                      <img
                        src={photo1}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                  </div>
                  <div className="mr-auto w-44 flex-none space-y-8 sm:mr-0 sm:pt-52 lg:pt-36">
                    <div className="relative">
                      <img
                        src={art1}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    <div className="relative">
                      <img
                        src={art2}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                  </div>
                  <div className="w-44 flex-none space-y-8 pt-32 sm:pt-0">
                    <div className="relative">
                      <img
                        src={art3}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    <div className="relative">
                      <img
                        src={art4}
                        alt=""
                        className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                      />
                      <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>

    )
}
